import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { Dashboard } from './pages/office/Dashboard';
import { FacilitiesConsole } from './pages/facilities/FacilitiesConsole';
import { ProjectsConsole } from './pages/projects/ProjectsConsole';
import { CampaignsConsole } from './pages/campaigns/CampaignsConsole';
import { IssuesConsole } from './pages/issues/IssuesConsole';
import { NoticesConsole } from './pages/notices/NoticesConsole';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  // One workspace per district office — every persona holds
  // DISTRICT_ADMINISTRATOR and/or DA_OFFICER and lands on the same district
  // dashboard; the sidebar itself is shown to everyone, individual actions
  // surface an inline notice when the signed-in persona's role lacks what a
  // given button requires (matches the fleet-wide "shared nav, per-action
  // gate" pattern — see homeaffairs-portal/server/personas.ts).
  return (
    <Routes>
      <Route
        element={
          <Shell
            title="Local Government Operations"
            items={[
              { to: '/dashboard', label: 'District Office', icon: '⌂' },
              { to: '/facilities', label: 'Facility Bookings', icon: '▦' },
              { to: '/projects', label: 'Community Projects', icon: '◫' },
              { to: '/campaigns', label: 'Participatory Budget', icon: '☰' },
              { to: '/issues', label: 'Local Issues', icon: '⚠' },
              { to: '/notices', label: 'Notice Board', icon: '▣' },
            ]}
          />
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="facilities" element={<FacilitiesConsole />} />
        <Route path="projects" element={<ProjectsConsole />} />
        <Route path="campaigns" element={<CampaignsConsole />} />
        <Route path="issues" element={<IssuesConsole />} />
        <Route path="notices" element={<NoticesConsole />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
